import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  ProductKitNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { ProductKit as ProductKitEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import ProductKitModel from "../../data/model/ProductKit";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { PageQueryOptions, pageQuery } from "../page-query";

const productKitsQuery = gql`
${ProductKitNoNestingFragment}
${PaginatedListMetaNoNestingFragment}
query GetProductKits(${listVariables}) {
    productKits(${listOptions}) {
        items {
           ...ProductKitNoNesting
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const productKitDefinition = new EntityResourceDefinition<
  ProductKitEntity,
  ProductKitModel
>({
  entity: "product_kits",
  query: productKitsQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.description = fetchedEntity.description || null;
    newEntity.price = fetchedEntity.price || 0;
    newEntity.kitId = fetchedEntity.kitId;
  },
  fetchEntities: (options?: PageQueryOptions) => {
    return pageQuery(client, "productKits", productKitsQuery, options);
  },
});
